import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useMonetization } from '../context/MonetizationContext';

// Dismissible bottom anchor ad — mobile only. Uses the AdSense "footer" slot
// when configured, otherwise a tasteful placeholder. Hidden on admin via App shell.
const StickyAnchorAd = () => {
  const { adsEnabled, adsenseClient, adSlots } = useMonetization();
  const [closed, setClosed] = useState(false);

  if (!adsEnabled || closed) return null;
  const slotId = adSlots && adSlots.footer;
  const live = adsenseClient && slotId;

  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-40">
      <div className="relative bg-white/95 backdrop-blur-md border-t border-[#E6D7A2] shadow-[0_-10px_30px_-18px_rgba(27,29,33,0.5)]">
        <button
          onClick={() => setClosed(true)}
          aria-label="Close ad"
          className="absolute -top-3 right-3 w-7 h-7 rounded-full bg-[#1B1D21] text-white inline-flex items-center justify-center shadow-md"
        >
          <X className="w-4 h-4" />
        </button>
        <div className="flex items-center justify-center" style={{ minHeight: 60 }}>
          <span className="absolute top-1 left-3 text-[9px] font-semibold tracking-[0.18em] uppercase text-[#b79b76]">
            Advertisement
          </span>
          {live ? (
            <ins
              className="adsbygoogle"
              style={{ display: 'block', width: '100%', height: 60 }}
              data-ad-client={adsenseClient}
              data-ad-slot={slotId}
              data-ad-format="horizontal"
              data-full-width-responsive="true"
            />
          ) : (
            <span className="text-[13px] text-[#b79b76]">Ad space</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default StickyAnchorAd;
